const technical_writes = [
    {
        title: 'Fraud Doesn’t Wait: Accelerating AI-Driven Detection with Latency Budgets',
        url: 'https://www.tecton.ai/blog/fraud-doesnt-wait-accelerating-ai-driven-detection-with-latency-budgets/',
    },
    {
        title: 'Powering Millions of Real-Time Rankings with Production AI',
        url: 'https://www.getyourguide.careers/posts/powering-millions-of-real-time-rankings-with-production-ai',
    },
    {
        title: 'Boost AI Fraud Model Performance with 3rd Party Data',
        url: 'https://www.tecton.ai/blog/ai-fraud-detection-3rd-party-data/',
    },
    {
        title: 'Productionizing Embeddings: Challenges and a Path Forward',
        url: 'https://www.tecton.ai/blog/productionizing-embeddings-challenges-and-a-path-forward/',
    },
    {
        title: 'High-Scale Feature Serving at Low Cost With Caching',
        url: 'https://www.tecton.ai/blog/high-scale-feature-serving-at-low-cost-with-caching-machine-learning/',
    },
    {
        title: 'Powering Millions of Real-Time Decisions with LyftLearn Serving',
        url: 'https://eng.lyft.com/powering-millions-of-real-time-decisions-with-lyftlearn-serving-9bb1f73318dc',
    },
    {
        title: 'Full-Spectrum ML Model Monitoring at Lyft',
        url: 'https://eng.lyft.com/full-spectrum-ml-model-monitoring-at-lyft-a4cdaf828e8f',
    },
    {
        title: 'Speeding Ahead with a Systematic Approach to Web Performance',
        url: 'https://eng.lyft.com/speeding-ahead-with-a-systematic-approach-to-web-performance-282b6cf8ae2',
    },
    {
        title: 'Leveraging Distributed Tracing and Container Cloning for Replay Debugging of Microservices',
        url: 'https://mihirmathur.com/thesis.pdf',
    },
    {
        title: 'WebJShrink: A Web Service for Debloating Java Bytecode',
        url: 'https://mihirmathur.com/fse20-webjshrink.pdf',
    },
    {
        title: 'Augmenting Stack Overflow with API Usage Patterns Mined from GitHub',
        url: 'https://mihirmathur.com/esec_fse18.pdf',
    },
];

export default technical_writes;
